<template>
  <modal :exibir="exibirModal" :titulo="tituloModal" :maxWidth="600" @close="$emit('fechar-modal')">
    <template #body>
      <div class="az-form-content cp-modal-form-content pa-4" style="height: 400px">
        <div class="mb-3">
          <label-personalizado nome-campo="Nome"></label-personalizado>
          <v-text-field
              id="nome"
              :value="nomeExibicao"
              v-validate="'required|max:50'"
              name="Nome"
              :counter="50"
              type="text"
              placeholder="Informe o nome"
              :disabled="true"
              dense
              outlined
              class="pt-0"
              :error-messages="errors.collect('Nome')"
          ></v-text-field>
        </div>

        <div class="mb-3">
          <label-personalizado nome-campo="CPF"></label-personalizado>
          <v-text-field
              :value="cpfParaCampo"
              placeholder="CPF do usuário"
              :disabled="true"
              dense
              outlined
              class="pt-0"
          ></v-text-field>
        </div>

        <div class="mb-0">
          <label-personalizado nome-campo="Documentos Selecionados" class="pb-2"></label-personalizado>
          <v-card outlined class="document-list-card">
            <v-card-text class="pa-3">
              <div v-if="documentos && documentos.length > 0">
                  <v-chip
                      v-for="(documento, index) in documentos"
                      :key="documento.idVirtualizado || documento.id || index"
                      color="grey lighten-3"
                      outlined
                      small
                      class="ma-1"
                  >
                    <v-icon left small>mdi-file-document</v-icon>
                    {{ getTituloDocumento(documento) }}
                  </v-chip>
                <v-divider class="my-2"></v-divider>
                <p class="text-caption grey--text text--darken-1 mb-0">
                  Total: {{ documentos.length }} documento{{ documentos.length > 1 ? 's' : '' }} selecionado{{ documentos.length > 1 ? 's' : '' }}
                </p>
              </div>
              <div v-else class="text-center pa-2">
                <v-icon size="48" color="grey lighten-1">mdi-file-document-outline</v-icon>
                <p class="text-body-2 grey--text text--darken-1 mt-2 mb-0">
                  Nenhum documento selecionado
                </p>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </template>

    <template #actions>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pb-3 pt-3">
        <botao-cancelar style="max-width: 60px" @cancelar="fecharModal">Cancelar</botao-cancelar>
        <botao-salvar style="max-width: 60px"
            :disabled="!ehFormularioValido"
            label="Assinar"
            @salvar="confirmarAssinatura"
        />
      </v-card-actions>
    </template>
  </modal>
</template>

<script>

import {actionTypes} from "@/commons/constants";
import Modal from "@/views/credenciamento/detalhe-credenciamento/commons/Modal.vue";
import LabelPersonalizado from "@/views/credenciamento/detalhe-credenciamento/commons/LabelPersonalizado.vue";
import BotaoSalvar from "@/views/credenciamento/detalhe-credenciamento/commons/BotaoSalvar.vue";
import BotaoCancelar from "@/views/credenciamento/detalhe-credenciamento/commons/BotaoCancelar.vue";

export default {
	name: 'formulario-assinatura-eletronica',
  components: {BotaoCancelar, BotaoSalvar, Modal, LabelPersonalizado },
  inject: ['$validator'],
	props: {
		documentos: {
			type: Array,
			default() {
				return []
			},
		},
		exibirModal: {
			type: Boolean,
			required: true,
		},
		tituloModal: {
			type: String,
			required: true,
		},
		idLicitacao: {
			type: [String, Number],
			required: true,
		},
	},
	data() {
		return {
			dadosAssinatura: {
				nome: null,
				email: null,
				cpf: null,
			},
		}
	},
	computed: {
		ehFormularioValido() {
			return this.errors.items.length === 0
		},
		ehApenasUmDocumentoSelecionado() {
			return this.documentos.length === 1
		},
		fornecedorDoDocumento() {
			if (!this.documentos || this.documentos.length === 0) return null
			const docComFornecedor = this.documentos.find(d => d && d.fornecedor)
			return docComFornecedor ? docComFornecedor.fornecedor : null
		},
		nomeExibicao() {
			const fornecedor = this.fornecedorDoDocumento
			return fornecedor && fornecedor.razaoSocial ? fornecedor.razaoSocial : this.dadosAssinatura.nome
		},
		cpfExibicao() {
			const fornecedor = this.fornecedorDoDocumento
			return fornecedor && fornecedor.cpfCnpj ? fornecedor.cpfCnpj : this.dadosAssinatura.cpf
		},
		cpfParaCampo() {
			const fornecedor = this.fornecedorDoDocumento
			const cpf = this.cpfExibicao
			// Se vier do fornecedor, não formatar
			if (fornecedor && fornecedor.cpfCnpj) {
				return cpf || ''
			}
			// Caso contrário (usuário), manter formatação azCpfCnpj se disponível
			const filtrosLocal = (this.$options && this.$options.filters) || {}
			const filtrosRoot = (this.$root && this.$root.$options && this.$root.$options.filters) || {}
			const format = filtrosLocal.azCpfCnpj || filtrosRoot.azCpfCnpj
			return format ? format(cpf) : (cpf || '')
		},
	},
	watch: {
		documentos: {
			handler() {
				this.$forceUpdate()
			},
			immediate: true,
			deep: true
		},
		exibirModal: {
			handler(newVal) {
				if (newVal) {
					this.$nextTick(() => {
						this.$forceUpdate()
					})
				}
			},
			immediate: true
		}
	},
	async created() {
    await this.buscarInformacoesUsuario()
	},
	methods: {
    async assinarIndividualmente() {
      this.habilitarLoadingGlobal()
      await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DOCUMENTO.ASSINAR_ELETRONICAMENTE, {
        idVirtualizado: this.documentos[0].idVirtualizado,
        idLicitacao: this.idLicitacao
      })
      this.desabilitarLoadingGlobal()

      this.$emit('assinatura-concluida')
    },
    async buscarInformacoesUsuario() {
			const usuario = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.BUSCAR_INFORMACOES_USUARIO)
			this.setDadosAssinatura(usuario)
		},
		async confirmarAssinatura() {
			await this.$validator._base.validateAll()
			if (!this.ehFormularioValido) {
				return
			}
			if (this.ehApenasUmDocumentoSelecionado) {
				await this.assinarIndividualmente()
			}
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		getTituloDocumento(documento) {
      if (!documento) {
        return 'Documento inválido'
      }

      return documento.titulo ? documento.titulo : documento.tituloDocumento;
		},
		setDadosAssinatura(dados) {
			this.dadosAssinatura.nome = dados.nome
			this.dadosAssinatura.email = dados.emailContato
			this.dadosAssinatura.cpf = dados.docChave
		},
	},
}
</script>
